<template>
  <div class="looking_site">
    <van-nav-bar title="账号设置" left-arrow @click-left="goback()" />

    <div class="site_form">
      <van-form
        label-width="100"
        :show-error="false"
        @submit="onSubmit"
        error-message-align="right"
      >
        <van-cell-group>
          <van-field
            input-align="right"
            required
            v-model="submitData.contactName"
            label="您的姓名"
            placeholder="请输入"
            :rules="[{ required: true, message: '请输入您的姓名' }]"
          />

          <van-field
            input-align="right"
            required
            v-model="submitData.contactNumber"
            label="联系电话"
            placeholder="请输入"
            :rules="[
              { required: true, message: '请输入联系电话' },
              { pattern: /^1[3456789]\d{9}$/, message: '电话格式错误！' },
            ]"
          />

          <van-field
            input-align="right"
            required
            v-model="fieldValue"
            readonly
            label="所在地区"
            placeholder="请选择所在地区"
            @click="showCascader = true"
            :rules="[{ required: true, message: '请选择所在地区' }]"
          />

          <van-field
            required
            input-align="right"
            v-model="submitData.type_name"
            label="场地类型"
            placeholder="请选择场地类型"
            is-link
            @click="showPlaceType = true"
            :rules="[{ required: true, message: '请选择场地类型' }]"
          />

          <van-field
            input-align="right"
            v-model="submitData.telephone"
            label="登录账号"
            placeholder="请输入登录账号"
            :rules="[{ required: true, message: '请输入登录账号' }]"
            disabled
          />

          <van-field
            required
            input-align="right"
            v-model="submitData.password"
            label="登录密码"
            placeholder="请输入登录密码"
            :rules="[{ required: true, message: '请输入登录密码' }]"
          />

          <van-field
            input-align="right"
            v-model="submitData.authorization"
            label="绑定微信号"
            placeholder="点击授权绑定"
            disabled
            readonly
            @click="wxPayAuthorize"
          >
          </van-field>
        </van-cell-group>

        <van-button block color="#0CA7F0" type="info" native-type="submit"
          >保存设置</van-button
        >
      </van-form>
    </div>

    <van-popup v-model="showCascader" round position="bottom">
      <van-cascader
        v-model="cascaderValue"
        title="请选择所在地区"
        :options="options"
        @close="showCascader = false"
        @finish="onFinish"
        :field-names="{
          text: 'name',
          value: 'area_code',
          children: 'children',
        }"
      />
    </van-popup>

    <van-action-sheet
      v-model="showPlaceType"
      :actions="placeType"
      cancel-text="取消"
      close-on-click-action
      @cancel="onCancel"
      @select="onSelectType"
    />
  </div>
</template>

<script>
import { Button } from "vant";
import { NavBar } from "vant";
import { Form, Field, CellGroup } from "vant";
import { RadioGroup, Radio } from "vant";
import { Icon } from "vant";
import { ActionSheet, Cascader, Popup, Uploader } from "vant";
import cityData from "@/assets/js/city.js";

export default {
  components: {
    [Button.name]: Button,
    [NavBar.name]: NavBar,
    [Form.name]: Form,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Icon.name]: Icon,
    [ActionSheet.name]: ActionSheet,
    [Cascader.name]: Cascader,
    [Popup.name]: Popup,
    [Uploader.name]: Uploader,
  },
  data() {
    return {
      // 场地方信息
      submitData: [],

      showPlaceType: false,
      placeType: [],
      placeTypeIndex: 0,

      showCascader: false,
      fieldValue: "",
      cascaderValue: "",
      // 选项列表，children 代表子选项，支持多级嵌套
      options: [],
    };
  },

  //初始化加载
  created() {
    this.options = cityData.data;
    //账号设置-查看
    this.siteSupplierAccountSettingsDetail();
  },

  methods: {
    //账号设置-查看
    siteSupplierAccountSettingsDetail() {
      var that = this;
      that.$api
        .siteSupplierAccountSettingsDetailAPI("")
        .then(function (res) {
          if (res.data.code === 200) {
            //处理所在地区数据
            that.fieldValue =
              res.data.data.province +
              " - " +
              res.data.data.city +
              " - " +
              res.data.data.district;

            //处场地类型数据
            var typeList = res.data.data.typeList;
            typeList.forEach((element) => {
              element.value = element.itemId;
              element.name = element.itemText;
            });

            // 处理微信授权数据
            if (res.data.data.openid === "") {
              res.data.data.authorization = "点击一键绑定微信号";
            } else {
              res.data.data.authorization = "已绑定微信号";
            }

            that.placeType = typeList;
            that.placeTypeIndex = Number(res.data.data.type);
            that.submitData = res.data.data;
          }
        })
        .catch(function (err) {
          console.log("error");
        });
    },

    onCancel() {},

    //返回上一页
    goback() {
      if (window.history.length <= 1) {
        this.$router.push({ path: "-" });
        return false;
      } else {
        this.$router.go(-1);
      }
    },

    // 全部选项选择完毕后，会触发 finish 事件
    onFinish({ selectedOptions }) {
      var info = selectedOptions.map((option) => option.name);
      this.fieldValue = selectedOptions.map((option) => option.name).join("-");
      this.submitData.province = info[0];
      this.submitData.city = info[1];
      this.submitData.district = info[2];
      this.showCascader = false;
    },

    // 选中类型
    onSelectType(item) {
      console.log(item);
      this.submitData.type = item.value;
      this.submitData.type_name = item.name;
      this.showPlaceType = false;
    },

    //点击选中场地类型
    changePlaceTypeIndex(index) {
      this.placeTypeIndex = index;
      this.placeInfo.type = Number(this.placeType[index].itemId);
    },

    //点击保存修改设置
    onSubmit() {
      var that = this;
      // that.$delete(that.submitData, "typeList");
      // that.$delete(that.submitData, "authorization");
      that.$api
        .siteSupplierAccountSettingsSaveAPI(that.submitData)
        .then(function (res) {
          if (res.data.code === 200) {
            that.$Notify({
              type: "success",
              message: "保存成功",
              onClose() {
                that.$router.go(-1);
              },
            });
          }
        })
        .catch(function (err) {
          console.log("error");
        });
    },

    //账号设置-绑定微信号
    wxPayAuthorize() {
      this.$router.push({ path: "/personal/setting" });
      // var that = this;
      // that.$api
      //   .wxPayAuthorizeAPI("")
      //   .then(function (res) {
      //     if (res.data.code === 200) {
      //       if (that.submitData.openid === res.data.data.openid) {
      //         that.$Notify({
      //           type: "success",
      //           message: "该微信已经进行绑定",
      //         });
      //       } else {
      //         that.submitData.openid = res.data.data.openid;
      //       }
      //     }
      //   })
      //   .catch(function (err) {
      //     console.log("error");
      //   });
    },
  },
};
</script>

<style lang="less" scoped>
.looking_site {
  display: flex;
  flex-direction: column;

  .site_form {
    height: auto;

    /deep/ .van-uploader__upload {
      width: 50px;
      height: 50px;
    }

    /deep/ .van-cell {
      align-items: center !important;
    }

    .form_tag {
      display: flex;
      justify-content: space-between;
      padding: 0px 20px;
    }

    .van-cell {
      display: flex;
      align-items: flex-start;
    }

    .form_feature {
      color: #646566;
      margin: 15px 10px;

      .fs28::after {
        position: absolute;
        left: 110px;
        color: #ee0a24;
        margin-top: 5px;
        font-size: 8px;
        content: "*";
      }

      .van-button {
        height: 35px;
        margin-top: 15px;
        margin-right: 15px;
      }
    }
  }

  .van-button {
    position: fixed;
    bottom: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/place/placeSetting.vue